/* 0422 gift rules. No DOM dependencies: the same engine is exercised by the tests. */
(function (root) {
  'use strict';
  const MARK = 'travel-bag-v1';
  const THRESHOLD = 25000000; // Shopify money: 250,000 COP * 100.
  const owned = item => item.properties?._0422_gift === MARK;
  // Liquid serializa las propiedades de la linea como lista de pares [[k,v]]; /cart.js las entrega como objeto.
  // Se normalizan ambas formas para que la identidad de la linea coincida (p. ej. preventas con propiedades de Globo).
  const asObject = value => Array.isArray(value) ? Object.fromEntries(value.filter(pair => Array.isArray(pair) && pair.length === 2)) : (value || {});
  const stable = value => JSON.stringify(Object.entries(asObject(value)).sort(([a],[b]) => a.localeCompare(b)));
  const identity = item => `${item.variant_id || item.id}|${item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || 0}|${stable(item.properties)}`;
  const fingerprint = s => `${s.currency}|${s.eligible_total}|${s.cart.items.filter(i=>!owned(i)).map(i=>identity(i)+':'+i.quantity).sort().join(';')}`;
  function locate(items, requested) {
    const exact = items.find(i => i.key === requested.key && identity(i) === identity(requested));
    if (exact) return exact;
    const matches = items.filter(i => identity(i) === identity(requested));
    if (matches.length !== 1) throw new Error('El carrito cambió. Revisa la cantidad y vuelve a intentarlo.');
    return matches[0];
  }
  async function reconcile(io, options = {}) {
    let s = await io.read();
    let notice = '';
    let selected = options.color;
    const failed = new Set();
    // Every iteration makes a bounded change or returns. Reads refresh changing line keys.
    for (let step = 0; step < 16; step++) {
      const gifts = s.cart.items.filter(owned);
      const candidates = s.candidates.filter(c => c.valid && c.id);
      const manual = s.cart.items.some(i => !owned(i) && candidates.some(c => c.product_id === i.product_id));
      const eligible = s.currency === 'COP' && s.eligible_total >= THRESHOLD;
      const key = fingerprint(s);
      if (!eligible || manual) {
        if (gifts.length) { await io.change(gifts[0].key,0); s=await io.read(); continue; }
        return {state:s,notice:manual ? 'Tu Travel Bag ya está en el carrito. Revisa el descuento aplicado por Shopify.' : ''};
      }
      if (gifts.length > 1) { await io.change(gifts[gifts.length-1].key,0); s=await io.read(); continue; }
      const gift = gifts[0];
      const current = gift && candidates.find(c=>c.id === gift.variant_id);
      if (gift && (!current || gift.quantity !== 1)) {
        await io.change(gift.key,current ? 1 : 0); s=await io.read(); continue;
      }
      if (gift && (!selected || selected === current.color)) {
        if (gift.final_line_price === 0) return {state:s,notice};
        // A private property never entitles a line to a discount. Fail closed.
        io.block(key);
        await io.change(gift.key,0); s=await io.read();
        return {state:s,notice:'No se pudo aplicar el regalo gratis. Lo retiramos para evitar un cobro.'};
      }
      const available = candidates.filter(c=>c.available && !failed.has(c.id));
      const next = selected ? available.find(c=>c.color===selected) : (available.find(c=>c.color==='cream') || available.find(c=>c.color==='brown'));
      if (!next) return {state:s,notice:gift ? 'Ese color no está disponible. Conservamos tu regalo actual.' : 'El regalo está temporalmente agotado o no disponible.'};
      if (!gift && io.blocked(key)) return {state:s,notice:'El regalo no está disponible para este carrito. Revisa tus descuentos.'};
      if (gift) {
        // Remove first: never create two promotional lines, even during a color change.
        await io.change(gift.key,0); s=await io.read();
      }
      try {
        await io.add(next.id, {_0422_gift:MARK});
        s=await io.read();
        // The next pass verifies the actual discounted price, not an assumed zero.
      } catch (error) {
        // Re-read before any retry: an interrupted response may have committed the add.
        s=await io.read();
        if (s.cart.items.some(owned)) { selected=undefined; continue; }
        if (error.status !== 422) {
          io.block(key);
          return {state:s,notice:'No pudimos confirmar el regalo. No se reintentará automáticamente.'};
        }
        failed.add(next.id);
        if (selected) {
          selected=undefined;
          notice='El color elegido se agotó. Seleccionamos el color disponible.';
        }
      }
    }
    throw new Error('No pudimos estabilizar el carrito. Reintenta antes de pagar.');
  }
  const api={MARK,THRESHOLD,owned,identity,locate,fingerprint,reconcile};
  if (typeof module !== 'undefined' && module.exports) module.exports=api;
  else root.Gift0422Core=api;
})(typeof window === 'undefined' ? globalThis : window);
